import ModalInformation from "@/app/components/ui/Modals/Information";
import { useBookedSlotsDetailsAPI } from "@/app/hooks/api_hooks/bookings/useBookedSlotsDetailsAPI";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { FaBath, FaCheckToSlot, FaUserDoctor } from "react-icons/fa6";
import { PiBookOpenLight } from "react-icons/pi";
import { IViewCommentsModalProps } from "../interface";

interface BookedSlotsDetailsModalState {
  slotId: string;
}

const BookedSlotsDetailsModal: React.FC<IViewCommentsModalProps> = () => {
  const { slotId } = useModalState("BOOKED_SLOTS_DETAILS") as BookedSlotsDetailsModalState;

  const { slotDetails, execute: fetchSlotDetails } = useBookedSlotsDetailsAPI();

  useEffect(() => {
    if (slotId) {
      fetchSlotDetails(slotId);
    }
  }, [slotId]);

  return (
    <ModalInformation
      modalId="BOOKED_SLOTS_DETAILS"
      title={
        <div className="flex justify-start items-center">
          {" "}
          <InformationCircleIcon className="w-6 h-6 mr-2" /> <span className="text-gray-700">Booked Slot Details</span>
        </div>
      }
    >
      <div className="p-4 text-sm">
        <p className="font-semibold flex justify-start items-center">
          <span className="text-blue-600">
            <PiBookOpenLight />
          </span>
          <span className="ml-1">Booking Details</span>
        </p>
        <div className="text-xs">
          <div className="text-xs">
            <span>Client Name</span> : <span className="text-gray-500">{slotDetails?.client_name}</span>
          </div>
          <div className="">
            Pet Name : <span className="text-gray-500">{slotDetails?.pet_name}</span>
          </div>
          <div className="">
            Pet Specie : <span className="text-gray-500">{slotDetails?.pet_species}</span>
          </div>
        </div>
        <p className="font-semibold mt-2 flex justify-start items-center gap-x-1">
          <span className="text-orange-600">
            <FaCheckToSlot />
          </span>
          <span className="">Slot Details</span>
        </p>
        <div className="text-xs">
          <div className="">
            <span>Timings </span> :{" "}
            <span className="text-gray-500">
              {slotDetails?.booking_start_time} to {slotDetails?.booking_end_time}
            </span>
          </div>

          <div className="">
            Clinic : <span className="text-gray-500">{slotDetails?.clinic}</span>
          </div>
        </div>
        <p className="font-semibold mt-2 flex justify-start items-center gap-x-1">
          <span className="text-blue-500">
            <FaBath />{" "}
          </span>
          <span>Service Details</span>
        </p>
        <div className="text-xs">
          <div className="">
            <span>Service & Sub Service </span> :{" "}
            <span className="text-gray-500">
              {slotDetails?.service_name} and {slotDetails?.sub_service_name}
            </span>
          </div>
        </div>
        <p className="font-semibold mt-2 flex justify-start items-center gap-x-1">
          <span className="text-green-500">
            <FaUserDoctor />
          </span>
          <span>Provider Details</span>
        </p>
        <div className="text-xs">
          <div className="">
            <span>Provider </span> : <span className="text-gray-500">{slotDetails?.provider}</span>
          </div>
          <div className="">
            <span>Created By</span> : <span className="text-gray-500"> {slotDetails?.created_by}</span>
          </div>
        </div>
      </div>
    </ModalInformation>
  );
};
export default BookedSlotsDetailsModal;
